import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { House, Users, EllipsisVertical, UserRoundCog, Layers3, HandCoins, HouseIcon } from "lucide-react";
import "./MobileNav.css";

function MobileNav() {
  const location = useLocation();
  const currentPath = location.pathname;
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleToggle = () => {
    setShowDropdown((prev) => !prev);
  };
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Determine if CRM should be active
  const isHome = ["/home"].includes(currentPath);
  const isCRMActive = ["/lead-list", "/deal-list", "/client-list", "/company-list", "/quote-list", "/walkthrough", "/taskmaster"].includes(currentPath);
  const isOperationsActive = ["/survey-list-view", "/sites", "/inspection", "/map"].includes(currentPath);
  const isFinanceActive = ["/sales-order", "/invoice", "/inventory", "/vendor", "/purchaseOrder-list-view", "/bill"].includes(currentPath);
  const isHRMActive = ["/employees", "/attendance-list", "/department-list"].includes(currentPath);
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const isModuleVisible = (moduleName) => modulesToShow.includes(moduleName);
  const modulesToShow = permissions.filter((module) => Object.values(module).some((value) => value === true && typeof value === "boolean")).map((module) => module.moduleName.toLowerCase());

  // Utility function to check if any submodules are visible
  const shouldShowParent = (subModules) => subModules.some(isModuleVisible);

  return (
    <div>
      <div className="card custom-footer position-fixed start-0 bottom-0 fixed-box" style={{ backgroundColor: "white", width: "100%", border: "1px solid #ff176b", padding: "0px" }}>
        <table className="p-3">
          <tbody>
            <tr>
              {/* Home Section */}
              {isHome ? (
                <td style={{ paddingLeft: "17px" }}>
                  <div className="div p-1" style={{ backgroundColor: "#ff176b", height: "30px", borderRadius: "10px", width: "100px", color: "white", textAlign: "center" }}>
                    Home
                  </div>
                </td>
              ) : (
                <td style={{ padding: "10px", color: "#1a202c" }}>
                  <Link to="/home">
                    <HouseIcon strokeWidth="1" />
                  </Link>
                </td>
              )}

              {/* CRM Section */}
              {/* CRM Section */}
              <td

                style={{
                  paddingLeft: "17px",
                  visibility: shouldShowParent(["lead", "quote", "walkthrough", "client", "company", "task master"]) ? "visible" : "hidden",
                }}
              >
                {isCRMActive ? (
                  <>
                    <div
                      className="div p-1"
                      style={{
                        backgroundColor: "#ff176b",
                        height: "30px",
                        borderRadius: "10px",
                        width: "100px",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      CRM
                    </div>

                    {/* Show CRM submenu only on CRM pages */}
                    {[
                      "/lead-list",
                      "/deal-list",
                      "/quote-list",
                      "/walkthrough",
                      "/client-list",
                      "/company-list",
                      "/taskmaster",
                    ].includes(currentPath) && (
                        <div
                          className="position-absolute bottom-100 start-0 d-flex gap-3 p-3 rounded-top-4 bg-white w-100 overflow-scroll"
                          style={{ boxShadow: "2px -2px 10px rgba(0, 0, 0, 0.2)" }}
                        >
                          {isModuleVisible("lead") && (
                            <Link
                              to="/lead-list"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/lead-list" ? "#ff176b" : "transparent",
                                color: currentPath === "/lead-list" ? "white" : "inherit",
                              }}
                            >
                              Leads
                            </Link>
                          )}
                          {isModuleVisible("lead" || "deal") && (
                            <Link
                              to="/deal-list"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/deal-list" ? "#ff176b" : "transparent",
                                color: currentPath === "/deal-list" ? "white" : "inherit",
                              }}
                            >
                              Deals
                            </Link>
                          )}
                          {isModuleVisible("quote") && (
                            <Link
                              to="/quote-list"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/quote-list" ? "#ff176b" : "transparent",
                                color: currentPath === "/quote-list" ? "white" : "inherit",
                              }}
                            >
                              Quote
                            </Link>
                          )}
                          {isModuleVisible("walkthrough") && (
                            <Link
                              to="/walkthrough"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/walkthrough" ? "#ff176b" : "transparent",
                                color: currentPath === "/walkthrough" ? "white" : "inherit",
                              }}
                            >
                              Walkthrough
                            </Link>
                          )}
                          {isModuleVisible("client") && (
                            <Link
                              to="/client-list"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/client-list" ? "#ff176b" : "transparent",
                                color: currentPath === "/client-list" ? "white" : "inherit",
                              }}
                            >
                              Clients
                            </Link>
                          )}
                          {isModuleVisible("company") && (
                            <Link
                              to="/company-list"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/company-list" ? "#ff176b" : "transparent",
                                color: currentPath === "/company-list" ? "white" : "inherit",
                              }}
                            >
                              Companies
                            </Link>
                          )}
                          {isModuleVisible("task master") && (
                            <Link
                              to="/taskmaster"
                              className="tab rounded-2 p-1 ps-2 pe-2"
                              style={{
                                backgroundColor: currentPath === "/taskmaster" ? "#ff176b" : "transparent",
                                color: currentPath === "/taskmaster" ? "white" : "inherit",
                              }}
                            >
                              Tasks
                            </Link>
                          )}
                        </div>
                      )}
                  </>
                ) : (
                  <Link to="/lead-list">
                    <UserRoundCog strokeWidth="1" />
                  </Link>
                )}
              </td>
              {/* Operations Module */}
              {shouldShowParent(["site", "survey", "inspection", "map"]) && (
                isOperationsActive ? (
                  <td style={{ paddingLeft: "17px" }}>
                    <div className="div p-1" style={{ backgroundColor: "#ff176b", height: "30px", borderRadius: "10px", width: "100px", color: "white", textAlign: "center" }}>
                      Operations
                    </div>
                    <div className="position-absolute bottom-100 start-0 d-flex justify-content-start p-3 rounded-top-4 bg-white w-100" style={{ boxShadow: "2px -2px 10px rgba(0, 0, 0, 0.2)" }}>
                      {isModuleVisible("site") && (
                        <Link
                          to="/sites"
                          className="tab rounded-2 p-1 ps-2 pe-2"
                          style={{
                            backgroundColor: currentPath === "/sites" ? "#ff176b" : "transparent",
                            color: currentPath === "/sites" ? "white" : "inherit",
                          }}
                        >
                          Site
                        </Link>
                      )}
                    </div>
                  </td>
                ) : (
                  <td style={{ padding: "10px", color: "#1a202c" }}>
                    <Link to="/sites">
                      <Layers3 strokeWidth="1" />
                    </Link>
                  </td>
                )
              )}

              {/* Finance Module */}
              {/* {shouldShowParent(["sales order", "invoice", "inventory", "vendor", "purchase order", "bill"]) && (
                isFinanceActive ? (
                  <td width="10%" style={{ paddingLeft: "17px" }}>
                    <div className="div p-1" style={{ backgroundColor: "#ff176b", height: "30px", borderRadius: "10px", width: "100px", color: "white", textAlign: "center" }}>
                      Finance
                    </div>
                    <div className="position-absolute bottom-100 start-0 d-flex justify-content-around p-4 rounded-top-4 bg-white w-100" style={{ boxShadow: "2px -2px 10px rgba(0, 0, 0, 0.2)" }}>
                      {isModuleVisible("sales order") && (
                        <Link to="/sales-order" className="tab rounded-2 p-1 ps-2 pe-2">
                          Sales Order
                        </Link>
                      )}
                      {isModuleVisible("invoice") && (
                        <Link to="/invoice" className="tab rounded-2 p-1 ps-2 pe-2">
                          Invoice
                        </Link>
                      )}
                    </div>
                  </td>
                ) : (
                  <td style={{ padding: "10px", color: "#1a202c" }}>
                    <Link to="/sales-order">
                      <HandCoins strokeWidth="1" />
                    </Link>
                  </td>
                )
              )} */}

              {/* HRM Module */}
              {shouldShowParent(["employee", "attendance", "department"]) && (
                isHRMActive ? (
                  <td style={{ paddingLeft: "17px" }}>
                    <div className="div p-1" style={{ backgroundColor: "#ff176b", height: "30px", borderRadius: "10px", width: "100px", color: "white", textAlign: "center" }}>
                      HRM
                    </div>
                    <div className="position-absolute bottom-100 start-0 d-flex justify-content-around p-4 rounded-top-4 bg-white w-100" style={{ boxShadow: "2px -2px 10px rgba(0, 0, 0, 0.2)" }}>
                      {isModuleVisible("employee") && (
                        <Link to="/employees" className="tab rounded-2 p-1 ps-2 pe-2"
                          style={{
                            backgroundColor: currentPath === "/employees" ? "#ff176b" : "transparent",
                            color: currentPath === "/employees" ? "white" : "inherit",
                          }}
                        >
                          Employees
                        </Link>
                      )}
                      {isModuleVisible("department") && (
                        <Link to="/department-list" className="tab rounded-2 p-1 ps-2 pe-2"
                          style={{
                            backgroundColor: currentPath === "/department-list" ? "#ff176b" : "transparent",
                            color: currentPath === "/department-list" ? "white" : "inherit",
                          }}
                        >
                          Department
                        </Link>
                      )}

                    </div>
                  </td>
                ) : (
                  <td style={{ padding: "10px", color: "#1a202c" }}>
                    <Link to="/employees">
                      <Users strokeWidth="1" />
                    </Link>
                  </td>
                )
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MobileNav;
